import { render, staticRenderFns } from "./WeekDays.vue?vue&type=template&id=a5a27e8c&scoped=true&"
import script from "./WeekDays.vue?vue&type=script&lang=js&"
export * from "./WeekDays.vue?vue&type=script&lang=js&"
import style0 from "./WeekDays.vue?vue&type=style&index=0&id=a5a27e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a27e8c",
  null
  
)

component.options.__file = "WeekDays.vue"
export default component.exports